import { useLayoutEffect } from 'react';
import { useStore } from 'react-redux';
import { useLocation } from 'react-router-dom';
import type { RootState } from '@/app/store/index';
import { useAppDispatch } from '@/app/store/hooks';
import { resetQuote } from '../store/quoteSlice';
import type { MountLoadMode } from '../utils/mountLoadMode';

/** An owned entry that opens a different quote by URL must not keep the held quote's local-only fields. */
export const useResetOnForeignFreshOpen = (mode: MountLoadMode, sameJourney: boolean): void => {
    const { key } = useLocation();
    const dispatch = useAppDispatch();
    const store = useStore<RootState>();

    useLayoutEffect(() => {
        if (sameJourney && mode === 'fresh-open' && store.getState().quote.quoteId) dispatch(resetQuote());
    }, [key, sameJourney, mode, store, dispatch]);
};
